module.exports = "/assets/data/b12aa4386f05bfca6afb0dce804f392a-G4.data.json";